import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";
import i18n from "@/i18n";

import { S1DataUploadTable } from "./table";
import { S1DataUploadEdit } from "./edit";

export default function S1DataUpload() {
  useEffect(() => {
    setDocumentTitle(
      `Quantilia | ${i18n.t("s1_data_upload.title", {
        ns: "tables",
        defaultValue: "Data Upload",
      })}`,
    );
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<S1DataUploadEdit />} />
      <Route index element={<S1DataUploadTable />} />
    </Routes>
  );
}
